module.exports = __webpack_public_path__ + "img/24.5bc5a672.jpg";